import colors from '@Common/assets/colors';
import { useQueueContext } from '@Context/QueueContext';
import { BounceLoader } from 'react-spinners';

interface Props {}

const Status: React.FC<Props> = () => {
  const { queueStatus } = useQueueContext();
  return (
    <>
      {queueStatus === 'No Pending Tasks' && (
        <label className="font-bold">{'No Pending Tasks'}</label>
      )}
      {queueStatus === 'In Progress' && (
        <span className="flex flex-row items-center gap-x-2">
          <BounceLoader
            data-testid="test-status-loader"
            size={15}
            color={colors.brandWarning[500]}
          />
          <label className="animate-pulse font-bold text-brandWarning-500">
            {'In Progress'}
          </label>
        </span>
      )}

      {queueStatus === 'Completed' && (
        <label className="animate-pulse font-bold text-brandSuccess-500">
          {'Completed'}
        </label>
      )}

      {queueStatus === 'Failed' && (
        <label className="animate-pulse font-bold text-brandRed-500">
          {'Failed'}
        </label>
      )}
    </>
  );
};

export default Status;
